import { render, staticRenderFns } from "./SocialMediaGrouped.vue?vue&type=template&id=25412f1a&"
import script from "./SocialMediaGrouped.vue?vue&type=script&lang=js&"
export * from "./SocialMediaGrouped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports